<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
       <el-form-item label="核销人名称：" prop="writeOffName">
          <el-input style="width: 424px;" v-model="ruleForm.writeOffName" placeholder="请输入核销人名称"></el-input>
        </el-form-item>
        <el-form-item label="核销人电话：" prop="writeOffPhone">
          <el-input style="width: 424px;" v-model="ruleForm.writeOffPhone" placeholder="请输入核销人电话"></el-input>
        </el-form-item>
        <el-form-item label="核销地址：" prop="writeOffAddress">
          <el-input style="width: 424px;" v-model="ruleForm.writeOffAddress" placeholder="地址输入格式：省-市-区-详细地址(详细地址不带-)"></el-input>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveSeleniumJourneyConfig, fetchSeleniumJourneyConfigDetail } from '@/api/journeySetting'
export default {
  name: 'WriteOff',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      ruleForm: {
         writeOffName:'',
         writeOffPhone:'',
         writeOffAddress:''
      },
      rules: {
        writeOffName: [
          { required: true, message: '请输入核销人名称', trigger: 'blur' }
        ],
        writeOffPhone: [
          { required: true, message: '请输入核销电话', trigger: 'blur' }
        ],
        writeOffAddress: [
          { required: true, message: '请输入核销地址', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    fetchSeleniumJourneyConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.writeOffName = data.writeOffName
        that.ruleForm.writeOffPhone = data.writeOffPhone
        that.ruleForm.writeOffAddress = data.writeOffAddress
      }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let writeOffName = that.ruleForm.writeOffName
      let writeOffPhone = that.ruleForm.writeOffPhone
      let writeOffAddress = that.ruleForm.writeOffAddress
      if(writeOffName == ''){
        this.$message.error('请输入核销人名称')
        return false
      }
      if(writeOffPhone == ''){
        this.$message.error('请输入核销电话')
        return false
      }
      if(writeOffAddress == ''){
        this.$message.error('请输入核销地址')
        return false
      }
      that.fullscreenLoading = true
      saveSeleniumJourneyConfig({writeOffName:writeOffName,writeOffPhone:writeOffPhone,writeOffAddress:writeOffAddress}).then((res) => {
         that.fullscreenLoading = false
         that.backDataFun(res)
      });
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/JourneyWriteOff.vue